import { createAndDownloadZip } from "./downloadZipFile";

export type Item = { 
  field: string, 
  value?: string | React.ReactNode, 
  state?: string | React.ReactNode, 
  extra?: Item,
  loanDocCreated?: any
}

export const buildDocItems = (
    label: string,
    doc: any,
    options?: { onClick?: () => void; state?: string },
    customClass?: string,
    valueDefault?: string | JSX.Element,
    showDocs?: boolean,
  ): Item[] => {
    if (!showDocs || !doc) {
      return [{
        field: label,
        state: options?.state,
        value: valueDefault
      }];
    }

    if ( showDocs && (doc.file || (doc?.files?.length === 1))) {
      const singleFile = doc.file || doc.files[0];

      return [{
        field: label,
        state: options?.state,
        loanDocCreated: !doc.key? doc: undefined,
        value: (
          <span
            className={customClass}
            onClick={options?.onClick ?? (() => window.open(`${singleFile.url}?preview=true&app=borrower`, "_blank"))}
          >
            {"Download ->"}
          </span>
        )
      }];
    }

    if (doc.files?.length > 1 && showDocs) {
      return [{
        field: label,
        state: options?.state,
        loanDocCreated: !doc.key ? doc : undefined,
        value: (
          <span
            className={customClass}
            onClick={async () => {
              await createAndDownloadZip(`${label}.zip`, doc.files);
            }}
          >
            {`Download ${doc.files.length} documents ->`}
          </span>
        )
      }];
    }

    return [{
      field: label,
      state: options?.state,
      value: valueDefault
    }];
  };